// ---------------
// NOUVEAU FICHIER : src/pages/Privacy.js
// ---------------
import React, { useState, useEffect } from 'react';

const Privacy = () => {
    const [showScrollButton, setShowScrollButton] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollButton(true);
            } else {
                setShowScrollButton(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <section className="page-hero">
                <div className="page-hero-content">
                    <h1>Politique de Confidentialité</h1>
                    <p>Dernière mise à jour : 5 août 2025</p>
                </div>
            </section>

            <section className="legal-page-container">
                <p>
                    WONYA SOFT S.A (« nous », « notre » ou « nos ») s'engage à protéger la vie privée des utilisateurs (« vous » ou « votre ») de notre site web https://wonyaso.com et de nos services. Cette Politique de Confidentialité décrit comment nous collectons, utilisons, divulguons et protégeons vos informations.
                </p>

                <article>
                    <h2>ARTICLE 1 : RESPONSABLE DU TRAITEMENT</h2>
                    <p>
                        Le responsable du traitement des données personnelles collectées est WONYA SOFT S.A, dont les informations légales sont détaillées dans nos Termes et Conditions Générales d'Utilisation.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 2 : DONNÉES PERSONNELLES COLLECTÉES</h2>
                    <p>
                        Dans le cadre de nos activités, nous sommes amenés à collecter les catégories de données suivantes :
                    </p>
                    <ul>
                        <li><strong>Données d'identification :</strong> Nom, prénom, date de naissance, copie de la pièce d'identité, adresse postale, adresse e-mail, numéro de téléphone.</li>
                        <li><strong>Données de connexion :</strong> Adresse IP, type de navigateur, logs de connexion, pages visitées.</li>
                        <li><strong>Données de transaction :</strong> Informations relatives aux paiements, transferts, achats effectués via nos services, incluant les détails du bénéficiaire et de l'expéditeur.</li>
                        <li><strong>Données de géolocalisation :</strong> Uniquement avec votre consentement explicite pour des services spécifiques (ex: localisation de points de service).</li>
                    </ul>
                </article>

                <article>
                    <h2>ARTICLE 3 : FINALITÉS DE LA COLLECTE</h2>
                    <p>
                        Vos données personnelles sont collectées et traitées pour les finalités suivantes :
                    </p>
                    <ul>
                        <li>Fourniture et gestion de nos services (création de compte, exécution des transactions).</li>
                        <li>Amélioration de nos services et personnalisation de votre expérience utilisateur.</li>
                        <li>Communication avec vous, y compris le support client et les informations marketing (avec votre consentement).</li>
                        <li>Respect de nos obligations légales et réglementaires, notamment en matière de lutte contre le blanchiment de capitaux et le financement du terrorisme (LBC-FT), conformément aux exigences de la Banque Centrale du Congo (BCC).</li>
                        <li>Sécurisation de notre plateforme et prévention de la fraude.</li>
                    </ul>
                </article>

                <article>
                    <h2>ARTICLE 4 : PARTAGE DES DONNÉES À DES TIERS</h2>
                    <p>
                        Nous ne vendons ni ne louons vos données personnelles. Cependant, nous pouvons les partager avec :
                    </p>
                    <ul>
                        <li>Nos prestataires de services techniques (hébergement, maintenance, sécurité) qui agissent en tant que sous-traitants.</li>
                        <li>Les autorités financières, judiciaires ou administratives compétentes, sur réquisition légale dans le cadre de nos obligations réglementaires.</li>
                        <li>Les partenaires bancaires et opérateurs de télécommunication impliqués dans l'exécution de vos transactions.</li>
                    </ul>
                    <p>
                        Tout partage de données est encadré par des contrats stricts assurant un niveau de protection adéquat.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 5 : DURÉE DE CONSERVATION</h2>
                    <p>
                        Nous conservons vos données personnelles pour la durée strictement nécessaire à la réalisation des finalités pour lesquelles elles ont été collectées. Les données de transaction sont conservées pour une durée de dix (10) ans après la clôture de la relation d'affaires, conformément aux obligations légales en matière de LBC-FT.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 6 : SÉCURITÉ DE VOS DONNÉES</h2>
                    <p>
                        Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles robustes pour protéger vos données contre la destruction, la perte, l'altération, la divulgation ou l'accès non autorisé. Celles-ci incluent le chiffrement des données (SSL/TLS), des contrôles d'accès stricts et des audits de sécurité réguliers.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 7 : VOS DROITS</h2>
                    <p>
                        Conformément à la <strong>Loi n° 20/017 du 25 novembre 2020</strong>, vous disposez des droits suivants sur vos données :
                    </p>
                    <ul>
                        <li><strong>Droit d'accès :</strong> Le droit de recevoir une copie des données que nous détenons sur vous.</li>
                        <li><strong>Droit de rectification :</strong> Le droit de demander la correction de données inexactes ou incomplètes.</li>
                        <li><strong>Droit à l'effacement (« droit à l'oubli ») :</strong> Le droit de demander la suppression de vos données, sous réserve de nos obligations légales de conservation.</li>
                        <li><strong>Droit d'opposition :</strong> Le droit de vous opposer au traitement de vos données pour des motifs légitimes.</li>
                    </ul>
                    <p>
                        Pour exercer ces droits, veuillez contacter notre Délégué à la Protection des Données (DPO) par e-mail à <a href="mailto:dpo@wonyapay.com">dpo@wonyapay.com</a>, en joignant une copie de votre pièce d'identité.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 8 : COOKIES</h2>
                    <p>
                        Notre Site utilise des cookies pour améliorer la navigation, analyser le trafic et assurer le bon fonctionnement des services. Un bandeau de consentement vous permet de gérer vos préférences lors de votre première visite. Vous pouvez modifier vos choix à tout moment.
                    </p>
                </article>
            </section>

            <style>{`
                .scroll-to-top-btn {
                    position: fixed;
                    bottom: 2rem;
                    right: 2rem;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
                    border: none;
                    color: white;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
                    transition: all 0.3s ease;
                    z-index: 999;
                }

                .scroll-to-top-btn:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
                }

                .scroll-to-top-btn:active {
                    transform: translateY(-1px);
                }

                .scroll-to-top-btn svg {
                    width: 24px;
                    height: 24px;
                }

                @media (max-width: 768px) {
                    .scroll-to-top-btn {
                        bottom: 1.5rem;
                        right: 1.5rem;
                        width: 48px;
                        height: 48px;
                    }

                    .scroll-to-top-btn svg {
                        width: 24px;
                        height: 24px;
                    }
                }

                @media (max-width: 480px) {
                    .scroll-to-top-btn {
                        bottom: 1rem;
                        right: 1rem;
                        width: 45px;
                        height: 45px;
                    }

                    .scroll-to-top-btn svg {
                        width: 20px;
                        height: 20px;
                    }
                }
            `}</style>

            {/* Bouton Scroll to Top */}
            {showScrollButton && (
                <button 
                    onClick={scrollToTop} 
                    className="scroll-to-top-btn"
                    title="Remonter en haut"
                    aria-label="Remonter en haut de la page"
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="18 15 12 9 6 15"></polyline>
                    </svg>
                </button>
            )}
        </>
    );
};

export default Privacy;
